import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ToastrModule } from 'ngx-toastr';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TooltipModule } from 'primeng/tooltip';

import { AppComponent } from './app.component';
import { NavComponent } from './nav/nav.component';
import { DescriptionComponent } from './description/description.component';
import { DescriptionFullComponent } from './description/description-full/description-full.component';
import { DescriptionMobileComponent } from './description/description-mobile/description-mobile.component';
import { PricesComponent } from './prices/prices.component';
import { BaseComponent } from './base/base.component';
import { ConfigService, initConfig } from '../services/config.service';
import { applicationHttpClientCreator, HttpExtendedService } from '../services/http-extended.service';
import { PicturesComponent } from './pictures/pictures.component';
import { PictureLoadingComponent } from './tools/picture-loading/picture-loading.component';
import { PreviewComponent } from './tools/preview/preview.component';
import { CalendarComponent } from './tools/calendar/calendar.component';
import { DiscoverComponent } from './discover/discover.component';
import { EquipmentComponent } from './equipment/equipment.component';
import { DiscoverPlaceComponent } from './discover/discover-place/discover-place.component';
import { ReviewsComponent } from './reviews/reviews.component';
import { ReviewComponent } from './reviews/review/review.component';
import { RatingComponent } from './tools/rating/rating.component';
import { EquipmentFullComponent } from './equipment/equipment-full/equipment-full.component';
import { EquipmentMobileComponent } from './equipment/equipment-mobile/equipment-mobile.component';
import { LinksComponent } from './links/links.component';
import { NewsComponent } from './news/news.component';
import { UsefullAddressesComponent } from './usefull-addresses/usefull-addresses.component';
import { ContactComponent } from './contact/contact.component';
import { LoginComponent } from './login/login.component';
import { EditDiscoverModalComponent } from './discover/edit-discover-modal/edit-discover-modal.component';
import { AvailabilitiesComponent } from './availabilities/availabilities.component';
import { ConfirmationService } from 'primeng/api';
import { HomeComponent } from './home/home.component';
import { GalleryComponent } from './tools/gallery/gallery.component';

@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    DescriptionComponent,
    DescriptionFullComponent,
    DescriptionMobileComponent,
    PricesComponent,
    BaseComponent,
    PicturesComponent,
    PictureLoadingComponent,
    PreviewComponent,
    DiscoverComponent,
    EquipmentComponent,
    EquipmentFullComponent,
    EquipmentMobileComponent,
    DiscoverPlaceComponent,
    GalleryComponent,
    ReviewsComponent,
    ReviewComponent,
    RatingComponent,
    LinksComponent,
    NewsComponent,
    UsefullAddressesComponent,
    ContactComponent,
    LoginComponent,
    EditDiscoverModalComponent,
    AvailabilitiesComponent,
    CalendarComponent,
    HomeComponent
  ],
  imports: [
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NgxPaginationModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgxSpinnerModule,
    ModalModule.forRoot(),
    ToastrModule.forRoot(),
    DropdownModule,
    CalendarModule,
    ConfirmDialogModule,
    TooltipModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initConfig,
      deps: [ConfigService],
      multi: true
    },
    {
      provide: HttpExtendedService,
      useFactory: applicationHttpClientCreator,
      deps: [HttpClient, ConfigService]
    },
    ConfirmationService
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
